import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { CalcScreen, CategoryCard } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type Calc = { title: string; description: string; screen: string };

const CALCS: Calc[] = [
  { title: 'Total Pressure', description: 'Total, static, and velocity pressure relationships', screen: 'AirflowTotalPressure' },
  { title: 'Coil Delta P', description: 'Pressure drop across heating/cooling coils using Cv', screen: 'HydronicDeltaPCoilDeltaP' },
  { title: 'Cv and GPM', description: 'Flow rate or valve coefficient from pressure drop', screen: 'HydronicDeltaPCvandGPM' },
  { title: 'Fan Horsepower', description: 'Fan horsepower from airflow and static pressure', screen: 'ElectricalMotorCalculationsFanHorsepower' },
  { title: 'Filter Pressure Drop', description: 'Filter loading pressure drop', screen: 'FilterPressureDrop' },
];

export default function TABPressureScreen() {
  const nav = useNavigation();
  return (
    <CalcScreen title="Pressure Calculations" subtitle="TAB · Pressure and pressure drop">
      <Text style={styles.sectionLabel}>Calculations</Text>
      {CALCS.map((c) => (
        <CategoryCard
          key={c.screen}
          title={c.title}
          description={c.description}
          cta="Open →"
          onPress={() => nav.navigate(c.screen as never)}
        />
      ))}
    </CalcScreen>
  );
}

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});
